<template>
    <div class="session-tracker">
        <div class="session-icon">
            <img src="@/assets/images/session-icon.png">
        </div>
        <div class="session-body">
            <div class="session-text">Session Data:</div>
            <div class="session-progress">
                <div class="session-bar">
                    <div class="bar-container">
                        <div class="bar-completed" v-bind:style="progBarStyle"></div>
                    </div>
                </div>
                <!-- <div class="session-go">
                    <div class="session-go-btn">
                        <span class="totally-not-vidbaby-icon tnc-icon-play"></span>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        created: function() {
            var self = this;
            vidbaby.$(document).on('na-response.vidbaby', (event, data) => {
                switch(data.customView) {
                    case 'GetTemp':
                        self.progress = 5;
                        break;
                    case 'ShowMedications':
                        self.progress = 75;
                        break;
                    case 'ShowConclusion':
                        self.progress = 100;
                        break;
                }
            });
            vidbaby.$(document).on('na-extractedEntity.vidbaby', (event, data) => {
                for(var i in data) {
                    switch(i) {
                        case 'temperature':
                            self.progress = 15;
                            break;
                        case 'systolic':
                        case 'diastolic':
                            self.progress = 30;
                            break;
                        case 'bloodOxygen':
                            self.progress = 45;
                            break;
                        case 'pulse':
                            self.progress = 50;
                            break;
                    }
                }
            });
        },
        data: function() {
            return {
                progress: 0
            }
        },
        computed: {
            progBarStyle: function() {
                return { width: this.progress + '%' };
            }
        }
    }
</script>
<style lang="stylus">
.session-tracker
    display: flex
    width: 430px
    margin: 2em auto
    .session-body
        flex: 1
        display: flex
        flex-direction: column
        text-align: left
        padding: 0 1em
        justify-content: center
        .session-text
            // opacity: 0.75
            line-height: 1em
        .session-progress
            display: flex
            align-items: center
            margin-top: 8px
            .session-bar
                flex: 1
                .bar-container
                    position: relative
                    background: rgba(226,226,226, 0.8)
                    border-radius: 3em
                    height: 15px
                    width: 100%
                    overflow: hidden
                    .bar-completed
                        position: absolute
                        top: 0
                        bottom: 0
                        left: 0
                        background: #28c5cc
                        // width: 50%
                        border-radius: 3em 0 0 3em
            // .session-go
            //     padding: 0 10px
            //     .session-go-btn
            //         width: 20px
            //         height: 20px
            //         border: none
            //         background: #fff
            //         border-radius: 100%
            //         color: #c6dd9c
            //         position: relative
            //         .totally-not-vidbaby-icon
            //             position: absolute
            //             top: 52%
            //             left: 53%
            //             transform: translate(-50%, -50%)
            //             font-size: 14px
</style>